import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import TransportPage from '../../views/TransportPage/';

class Transroute extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			vno : '',
			rcode : '',
			startplace : '',
			stopplace : '',
			_message : '',
			alertClass :'',
			vehi : [],
			id : '',
		  _redirect : false,
		  posts: []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("rouform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.vno && this.state.rcode && this.state.startplace && this.state.stopplace){
			$("#showLoader").show();
			PostData('transport/addroute',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Route Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("rouform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('transport/deleteroute',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Route Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Route',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getvehicleno();
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();	
		GetData('transport/getroute').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Department **/
	getvehicleno(){
		
		GetData('transport/getvehicle').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					vehi : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/transport/editroute/' + this.state.idd} />);

	}
	
	var veh = this.state.vehi;
	
    return (
		<div>
		  <TransportPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="rouform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Add Route</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<div className={this.state.alertClass}>
									{this.state._message}
								</div>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Vehicle No <span className="text-danger">*</span></Label>
								  <select name="vno" onChange={this.onChange} className="form-control" required>
									<option value="">Select</option>
									{
										veh.map(function (item) {
											return <option value={item.id }>{item.regno}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Route Code <span className="text-danger">*</span></Label>
								  <Input type="text" name="rcode" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Route Start Place <span className="text-danger">*</span></Label>
								  <Input type="text" name="startplace" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Route Stop Place <span className="text-danger">*</span></Label>
								  <Input type="text" name="stopplace" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				  <Col md="7">
				   <Card>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Vehicle No</th>
								<th>Code</th>
								<th>Start Place</th>
								<th>End Place</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.posts.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.vno}</td>
									<td>{item.routecode}</td>
									<td>{item.startplace}</td>
									<td>{item.stopplace}</td>
									<td>
										<button name="editsub" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
										&nbsp;&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>

							 )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Transroute;


// WEBPACK FOOTER //
// ./src/transport/Transroute/Transroute.js